import {useTranslation} from 'react-i18next';
import {
  BannerLink,
  Banner,
  InlineContent,
  TopRow,
  Subtitle,
  Price,
  RightText,
  Separator,
  Logo,
  DiscountCode,
  BannerMobileWrapper,
} from './styled';

import bigBgImage from './assets/new-desktop-banner.jpg?no-inline';
import bgImage from './assets/new-mobile-banner.webp?no-inline';
import logo from './assets/gigsky-logo.webp?no-inline';
import {GIGSKY_LINK} from './constants';

export function GigSkyBannerMobile() {
  const {t} = useTranslation();

  return (
    <BannerMobileWrapper className="gigsky-banner-mobile">
      <BannerLink href={GIGSKY_LINK} target="_blank">
        <Banner
          $bigBgImage={bigBgImage}
          $bgImage={bgImage}
          $logo={logo}
          className="gigsky-banner-mobile__banner"
        >
          <InlineContent>
            <TopRow>
              <Logo src={logo} alt="gigsky-logo" height="19" width="100" />
              <Separator />
              <Price>{t('gigsky.starting_price')}</Price>
            </TopRow>

            <Subtitle className="gigsky-banner-mobile__subtitle">
              {t('gigsky.travel_peacefully')}
            </Subtitle>

            <RightText className="gigsky-banner-mobile__right-text">
              {t('gigsky.discount_prefix')}{' '}
              <DiscountCode>{t('gigsky.discount_code_value')}</DiscountCode>
            </RightText>
          </InlineContent>
        </Banner>
      </BannerLink>
    </BannerMobileWrapper>
  );
}
